import donateToCharityApiCall from '@ynap/api-utils/src/cart/donateToCharity'
import { getWatsonConfig } from '@ynap/cart-state/src/selectors/getConfig'
import { DONATE_TO_CHARITY_REQUEST, DONATE_TO_CHARITY_SUCCESS, DONATE_TO_CHARITY_ERROR } from '../constants/ActionTypes'
import { raygun } from '@ynap/clientside-monitoring'

import type { Dispatch } from 'redux'
import type { StoreState } from 'app/state/types'

const donateToCharity = (orderId: string, charityName: string, amount: number) => {
    return async (dispatch: Dispatch, getState: () => StoreState, fetch: WindowOrWorkerGlobalScope['fetch']) => {
        const state = getState()
        const watsonConfig = getWatsonConfig(state)
        const { uberToken } = watsonConfig

        dispatch({ type: DONATE_TO_CHARITY_REQUEST })

        const donateToCharityRequest = donateToCharityApiCall({ ...watsonConfig, uberToken, body: { orderId, charityName, amount } })

        try {
            const response: Response = await fetch(donateToCharityRequest, { errorTags: ['donateToCharityError'] })

            const json = await response.json()

            const { status, ok } = response

            if (!ok) {
                raygun.helpers.agent('send', {
                    error: new Error(`donation API NOT OK - status ${status}`),
                    tags: ['checkout', 'order confirmation', 'donation', status],
                })
                const { errors = [] } = json

                let key = DONATE_TO_CHARITY_ERROR
                if (errors.length > 0) {
                    key = errors[0].errorKey
                }

                return dispatch({
                    type: DONATE_TO_CHARITY_ERROR,
                    error: { errorKey: key },
                })
            }

            return dispatch({ type: DONATE_TO_CHARITY_SUCCESS })
        } catch (error: unknown) {
            raygun.helpers.agent('send', { error, tags: ['checkout', 'order confirmation', 'donation'] })
            return dispatch({
                type: DONATE_TO_CHARITY_ERROR,
                error: { errorKey: DONATE_TO_CHARITY_ERROR },
            })
        }
    }
}

export default donateToCharity
